function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMergePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2094.17,294.292l-255.209,-255.209c-24.791,-25.037 -58.958,-39.083 -94.375,-39.083l-681.666,-0c-147.292,-0 -266.667,119.417 -266.667,266.667l0.081,1066.67c3.669,147.5 123.252,266.667 270.336,266.667l800,0c146.666,0 266.666,-120 266.666,-266.667l0,-944.791c0,-35.334 -14.166,-69.25 -39.166,-94.25Zm-160.834,1039.04c0,36.817 -29.85,66.667 -66.666,66.667l-803.75,0c-36.825,0 -66.667,-29.85 -66.667,-66.667l0,-1066.12c0,-36.816 29.85,-66.666 66.667,-66.666l533.333,-0l3.75,199.458c0,73.625 59.708,133.333 133.333,133.333l196.25,0l0,800l3.75,0Zm-800,533.334c0,36.816 -29.85,66.666 -66.666,66.666l-803.75,0c-36.825,0 -66.667,-29.85 -66.667,-66.666l3.667,-1066.25c-0,-36.817 29.85,-66.667 66.666,-66.667l400.084,-0l-0,-200.417l-400.042,0c-147.292,0 -266.667,119.375 -266.667,266.667l0.041,1066.67c0.009,147.083 119.418,266.666 266.668,266.666l800,0c146.666,0 266.666,-120 266.666,-266.666l0,-133.334l-196.25,0l-3.75,133.334Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.770297,0,-219.222)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "1002.37px",
    y: "1669.34px",
    style: {
      fontFamily: "'DINCondensed-Bold', 'DIN Condensed'",
      fontWeight: 700,
      fontStretch: "condensed",
      fontSize: "752.074px"
    }
  }, "PDF")), /*#__PURE__*/React.createElement("path", {
    d: "M389.027,892.836c-19.574,-0.199 -35.427,-25.846 -35.427,-57.407c0,-31.685 15.977,-57.409 35.657,-57.409l150.4,-0l0.231,0.001c19.573,0.199 35.426,25.846 35.426,57.408c0,31.685 -15.977,57.409 -35.657,57.409l-150.4,-0l-0.23,-0.002Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.027,1190.72c-19.574,-0.199 -35.427,-25.846 -35.427,-57.407c0,-31.685 15.977,-57.409 35.657,-57.409l150.4,-0l0.231,0.001c19.573,0.199 35.426,25.846 35.426,57.408c0,31.684 -15.977,57.408 -35.657,57.408l-150.4,0l-0.23,-0.001Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.027,1041.66c-19.574,-0.199 -35.427,-25.846 -35.427,-57.407c0,-31.685 15.977,-57.409 35.657,-57.409l150.4,-0l0.231,0.001c19.573,0.199 35.426,25.846 35.426,57.408c0,31.685 -15.977,57.409 -35.657,57.409l-150.4,-0l-0.23,-0.002Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.489,1684.21c0,-28.268 45.352,-271.235 45.352,-271.235c-0,-38.252 31.056,-69.308 69.308,-69.308l88.617,-0c38.252,-0 69.308,31.056 69.308,69.308c-0,0 45.351,242.967 45.351,271.235c-0,87.737 -71.231,158.968 -158.968,158.968c-87.736,-0 -158.968,-71.231 -158.968,-158.968Zm83.538,24.029c-19.574,-0.199 -35.427,-25.846 -35.427,-57.408c0,-31.684 15.977,-57.409 35.657,-57.409l150.4,0l0.231,0.002c19.573,0.199 35.426,25.846 35.426,57.407c0,31.685 -15.977,57.409 -35.657,57.409l-150.4,0l-0.23,-0.001Z",
    style: {
      stroke: "#000",
      strokeWidth: "4.17px"
    },
    fillRule: "evenodd"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergePdf);
export default __webpack_public_path__ + "static/media/merge_pdf.1d844f70bbc10271425676c38ac3f68d.svg";
export { ForwardRef as ReactComponent };